// src/metadata/lang.ts
const createLang = () => {
	return (pageContext) => {
		return pageContext.localeId;
	};
};
export { createLang };

//# sourceMappingURL=lang.js.map